import type { NodeAction, NodeDesignsEntity, NodeDesignsRevision } from "../../schemas/index.ts";

export const anyReservedActions = (entries: NodeDesignsRevision[]) =>
  !!entries.find(({ actions }) => actions.find(isReservedAction));

export const isReservedAction = (action: NodeAction) => action.type === "UPDATE_VERSIONS";

// NodeDesignsClientEntity
export type NodeDesignsClientEntity = Omit<NodeDesignsEntity, "unappliedRevisions" | "maxUnappliedRevisions"> & {
  appliedRevisions: NodeDesignsEntity["unappliedRevisions"];
  server?: Pick<NodeDesignsEntity, "nodeDesigns" | "revision" | "unappliedRevisions" | "maxUnappliedRevisions">;
};
